import { useState } from "react"
import { useTranslation } from "lib/i18n/translation"
import { metadata, FEATURE_GUEST_CITATION, FEATURE_GUEST_CITATION_AUTHOR } from "lacinetek-common/src/metadata"
import image, { CATEGORY_BONUS } from "lacinetek-common/src/images"
import { styledContent } from "lib/tools/contents"
import { FETCH_KINOW_CATEGORY_VIDEO } from "lib/graphql/queries"
import { useApolloClient } from "@apollo/react-hooks"

export const Guest = ({ block, loading }) => {
	const { c } = useTranslation("common")

	const authorSentence = metadata(block, FEATURE_GUEST_CITATION_AUTHOR)
	const guestSentence = metadata(block, FEATURE_GUEST_CITATION)

	if (!authorSentence && !guestSentence) {
		return null
	}

	return (
		<section id={`${loading ? " skeleton-container" : ""}`}>
			<h2 className="section-title icon-guest">{c("guest-of-the-month-strong")}</h2>
			<div className={`splitted selection-guest`}>
				<GuestVideoPlayer block={block} loading={loading} />
				{
					(authorSentence && authorSentence != "")
					&& <div className="infos">
						{
							(guestSentence &&guestSentence !== "")
							&& <div className={`quote ${loading ? "skeleton" : ""}`}>
								<blockquote>{styledContent(guestSentence)}</blockquote>
							</div>
						}
						<span className={`source ${loading ? "skeleton" : ""}`} dangerouslySetInnerHTML={{ __html: authorSentence }} />
					</div>
				}
			</div>
		</section >
	)
}

const GuestVideoPlayer = ({ block, loading }) => {
	const [loadingVideo, setLoadingVideo] = useState(false)
	const [videoUrl, setVideoUrl] = useState(null)

	const client = useApolloClient()

	const showVideo = () => {
		setLoadingVideo(true)
		client.query({ query: FETCH_KINOW_CATEGORY_VIDEO, variables: { id: block.id } })
			.then(({ data: { cms: { categories: { items: [{ videos: { items: videos } }] } } } }) => {
				if (videos.length && videos[0].player) {
					setVideoUrl(videos[0].player.url)
				} else {
					setVideoUrl(null)
				}
				setLoadingVideo(false)
			})
	}

	return (
		<div className={`videoplayer-container ${loading ? "skeleton" : ""}`}>
			{
				videoUrl
					? <div className="youtube videoplayer">
						<iframe src={videoUrl} allow="autoplay ; fullscreen ; encrypted-media" allowFullScreen />
					</div>
					: <div data-video="byJOxaEVyng" className="youtube videoplayer" style={{ backgroundImage: `url(${image(block, CATEGORY_BONUS)})` }}>
						<div className={loadingVideo ? "is-loading" : "play"} style={loadingVideo ? { position: "absolute", top: "50%", left: "50%" } : {}} onClick={showVideo}></div>
					</div>
			}
		</div>
	)
}
